import { Route, Switch, Redirect } from 'react-router-dom';
import NotFound from 'pages/NotFound/NotFound';
import { OrganizationsPage } from 'pages/Organizations';
import { UsersPage } from 'pages/Users';
import { ToursPage } from './pages/Tours';

export const DefaultRoutes = {
  OrganizationsPage: '/',
  UsersPage: '/users',
  ToursPage: '/tours',
};

export const routes = (
  <Switch>
    <Route exact path={DefaultRoutes.OrganizationsPage} component={OrganizationsPage} />
    <Route exact path={`${DefaultRoutes.UsersPage}/:organizationId`} component={UsersPage} />
    <Route exact path={`${DefaultRoutes.ToursPage}/:organizationId`} component={ToursPage} />
    <Redirect exact from={'/organization_reassigned'} to={DefaultRoutes.OrganizationsPage} />
    <Route component={NotFound} />
  </Switch>
);
